import React, { useEffect, useRef } from 'react'
import Viewer from './viewer'

export const closest = (el, fn) => {
    return el && (fn(el) ? el : closest(el.parentNode, fn))
}

export const openPhotoSwipe = (index, galleryElement) => {
    const pswpElement = galleryElement

    let gallery
    let options

    options = {
        url(image) {
            return image.parentNode.href
        },
        hidden() {
            this.viewer.destroy()
        }
    }

    if (!pswpElement) {
        return
    }

    // Pass data to PhotoSwipe and initialize it
    gallery = new Viewer(pswpElement, options)

    gallery.view(index)
}

export const onThumbnailsClick = (evt, el) => {
    const e = evt || window.event
    const eTarget = e.target || e.srcElement

    // 阻止事件冒泡，数据看板中的列表是点击整行跳转，和点击图片放大会有冲突。
    // e.stopPropagation() // 不能在这里阻止冒泡会和图片上传冲突

    const clickedListItem = closest(eTarget, el => {
        return el.tagName && el.tagName.toUpperCase() === 'FIGURE'
    })

    if (!clickedListItem) {
        return
    }

    if (clickedListItem) {
        e.preventDefault ? e.preventDefault() : (e.returnValue = false)
    }

    const childNodes = el.getElementsByTagName('figure')
    const numChildNodes = childNodes.length
    let nodeIndex = 0
    let index

    for (let i = 0; i < numChildNodes; i++) {
        if (childNodes[i].nodeType !== 1) {
            continue
        }

        if (childNodes[i] === clickedListItem) {
            index = nodeIndex
            break
        }
        nodeIndex++
    }

    if (index >= 0) {
        // open PhotoSwipe if valid index found
        openPhotoSwipe(index, el)
    }
    return false
}

const initGallery = el => {
    el.onclick = evt => onThumbnailsClick(evt, el)
}

export const wrapperGallery = Component => {
    return props => {
        const $el = useRef(null)

        useEffect(() => {
            if (!$el.current) {
                return
            }

            initGallery($el.current)
        }, [])

        return <Component ref={$el} {...props} />
    }
}
